module.exports = __webpack_public_path__ + "static/media/Group 12.772e4c5a.svg";